@if ((redirectToCase() | async)) {<div></div>}